import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';
import { Capacitor } from '@capacitor/core';

// eslint-disable-next-line no-unused-vars
import { Router } from 'react-router-dom'; // leaving here as Sentry docs recommend that it is in score
// eslint-disable-next-line import/no-extraneous-dependencies
import Environment from './helpers/environment';

// Enable Sentry for native platforms on all environments
const sentryEnabled = Capacitor.isNativePlatform();

// monitor/trace as much activity as possible in dev/staging, and scale back in production
const tracesSampleRate = Environment.isDevMode ? 1.0 : 0.1;
const replaysSessionSampleRate = Environment.isDevMode ? 1.0 : 0.1;
const replaysOnErrorSampleRate = 1.0;

const initializeSentry = () => {
  if (!sentryEnabled) {
    return;
  }

  Sentry.init(
    {
      dsn: 'https://65f9101e857d6c08a7c8c2175bcdceea@o4505750486450176.ingest.sentry.io/4505755924889600',
      environment: Environment.current,
      integrations: [SentryReact.replayIntegration(), SentryReact.browserTracingIntegration(), SentryReact.inboundFiltersIntegration()],
      tracePropagationTargets: ['all'], // todo: possible target for refinement

      ignoreErrors: [
        'DataCloneError',
        'The object can not be cloned.',
        /DataCloneError/,
        'Twilsock: request timeout',
        /Twilsock: request timeout/,
        (error) => error.name === 'DataCloneError'
          || error.message?.includes('DataCloneError')
          || error.message?.includes('can not be cloned')
          || error.message?.includes('Twilsock: request timeout'),
      ],
      beforeSend: (event) => {
        console.log('Captured event:', event);
        return event;
      },

      // Performance Monitoring
      tracesSampleRate,

      // Session Replay
      replaysSessionSampleRate,
      replaysOnErrorSampleRate,

      beforeBreadcrumb: (breadcrumb) => {
        // Avoid capturing non-serializable data
        if (breadcrumb.data && typeof breadcrumb.data !== 'string') {
          // eslint-disable-next-line no-param-reassign
          breadcrumb.data = JSON.stringify(breadcrumb.data, null, 2);
        }
        return breadcrumb;
      },
    },
    SentryReact.init,
  );
};

export { initializeSentry };
